import { render, staticRenderFns } from "./CIndex.vue?vue&type=template&id=2b12a256&scoped=true&"
import script from "./CIndex.vue?vue&type=script&lang=js&"
export * from "./CIndex.vue?vue&type=script&lang=js&"
import style0 from "./CIndex.vue?vue&type=style&index=0&id=2b12a256&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12a256",
  null
  
)

export default component.exports